<template>
  <div ref="totalRef" class="subpage">
    <Header v-if="$route.query.platform !== 'mini'" ref="navBarRef" title="报数起卦" :is-sub-page="true"></Header>
    <div ref="contentRef" class="form-content">
      <div style="padding-bottom: 25.4%; height: 0; margin-top: 70px; margin-bottom: 30%;">
        <img src="@/assets/images/backgrounds/bg-bsqg.png" alt="pic" class="bg-img"/>
      </div>
      <Form
        ref="formRef"
        :models="model"
        :formFields="fields"
        :items="items"
        btnMsg="立即起卦"
        @submitClick="submitReport"
      ></Form>
    </div>
  </div>
</template>

<script>
import Form from '../../components/Form'
import Header from '@/components/Header'

export default {
  name: 'ForecastReport',
  components: {
    Header,
    Form
  },
  data () {
    return {
      backgroundUrl: '',
      computedHeight: 0,
      isComputed: false,
      isNeed: false,
      options: {
        startY: ''
      },
      model: {
        inputValue: '',
        inputValueSec: '',
        userValue: ''
      },
      items: ['input', 'input', 'button', 'userradio'],
      fields: [
        {
          type: 'input',
          modelKey: 'inputValue',
          label: '数字一',
          props: {
            placeholder: '请输入1-10之间的整数'
          },
          rules: {
            type: 'number',
            required: true,
            min: 1,
            max: 10
          },
          messages: {
            required: '请输入数字'
          }
        },
        {
          type: 'input',
          modelKey: 'inputValueSec',
          label: '数字二',
          props: {
            placeholder: '请输入1-10之间的整数'
          },
          rules: {
            type: 'number',
            required: true,
            min: 1,
            max: 10
          },
          messages: {
            required: '请输入数字'
          }
        },
        {
          type: null
        },
        {
          type: 'radio-group',
          modelKey: 'userValue',
          props: {
            options: ['我已阅读并同意《用户隐私协议》'],
            horizontal: true
          },
          rules: {
            required: true
          }
        }
      ]
    }
  },
  mounted () {
    document.title = this.$route.query.title
  },
  methods: {
    submitReport () {
      console.log('报数起卦' + `报数起卦(${this.model.inputValue},${this.model.inputValueSec})`)
      this.$store.commit('setForecast', `报数起卦(${this.model.inputValue},${this.model.inputValueSec})`)
      this.$store.commit('setForecastNum', { num1: this.model.inputValue, num2: this.model.inputValueSec })

      this.$router.push({
        path: '/plum/reportresult',
        query: {
          platform: this.$route.query.platform,
          title: `报数起卦(${this.model.inputValue},${this.model.inputValueSec})`
        }
      })
    }
  }

}
</script>

<style lang="stylus" scoped src="@/style/form.styl">
</style>

<style lang="stylus" scoped>
.subpage
  background url("~@/assets/images/backgrounds/bg.png") no-repeat center
  background-size 100% 100%
</style>

<style lang="stylus">
body
  background-color #EFE9E0
</style>
